
import { Vue, Component, Prop } from 'vue-property-decorator';
import { HistoryItemType } from '@/features/shipment-history/types';
import { PackageType } from '@/features/shipment/types';

@Component
export default class PackageTypeColumn extends Vue {
  @Prop({ required: true }) item!: HistoryItemType;

  get packageType(): keyof typeof PackageType {
    return this.item.packageType;
  }

  get packageCount(): number {
    return this.item.packages.length;
  }

  private PackageType = PackageType;
}
